import {appApiFetchJson} from 'common/report/queries/utils';

export function updateTeamSensitivity(id: number, sensitivity: boolean, projectId: string): Promise<any> {
  return appApiFetchJson(`/api/app/projects/${projectId}/sensitivity/teams`, {
    body: JSON.stringify({[id]: sensitivity}),
    method: `PATCH`,
  });
}

export function updateUserSensitivity(email: string, sensitivity: boolean, projectId: string): Promise<any> {
  return appApiFetchJson(`/api/app/projects/${projectId}/sensitivity`, {
    body: JSON.stringify({[email]: sensitivity}),
    method: `PATCH`,
  });
}
